import { Route, Routes } from "react-router-dom";
import "./App.css";
import Drop from "./router/drop-list/drop-list.components";
import Footer from "./router/footer/footer.component";
import Home from "./router/home/home.component";
import Navigation from "./router/navigation/navigation.component";

import ProtectedRoute from "./ProtectedRoute";
import AboutUsPage from "./router/about-us-page/about-us-page.component";
import Cart from "./router/cart/cart-component";
import CheckoutComponent from "./router/checkout/checkout.component";
import ContactUsPage from "./router/contact-us-page/contact-us-page.component";
import FaqPage from "./router/faq-page/faq-page/faq-page.component";
import LoginPage from "./router/login-page/login-Register";
import NavigationMiddleLogo from "./router/navigation-middle-logo/navigation-middle-logo.component";
import OrderFailurePage from "./router/OrderFailurePage/OrderFailurePage";
import OrderSuccessPage from "./router/OrderSuccessPage/OrderSuccessPage";
import PrivacyPolicyPage from "./router/privacy-policy-page/privacy-policy-page/privacy-policy-page.component";
import ProductPage from "./router/product-page/product-page.component";
import ProfilePage from "./router/profile-page/profile-page";
import ShopDrop from "./router/shop-drop/shop-drop.component";
import Shop from "./router/shop/shop.component";
import AllProducts from "./router/all-products/all-products";
import UpdatePage from "./router/Update-page/Update-Page";
import ForgetPassword from "./router/forget-password/ForgetPassword";

function App() {
  return (
    <Routes>
      {/* مسیر اصلی شامل Navigation و Footer */}
      <Route path="/" element={<Navigation />}>
        <Route path="/" element={<Footer />}>
          <Route index element={<Home />} />
        </Route>
      </Route>
      <Route path="/" element={<NavigationMiddleLogo />}>
        <Route path="/" element={<Footer />}>
          <Route path="product-page/:id" element={<ProductPage />} />
          <Route path="shop-page" element={<Shop />} />
          <Route
            path="/shop-drop-page"
            element={
              <ProtectedRoute requiredPassword="1405">
                <ShopDrop />
              </ProtectedRoute>
            }
          />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<CheckoutComponent />} />
          {/* <Route path="/all-products" element={<AllProducts />} /> */}
          <Route path="/faq-page" element={<FaqPage />} />
          <Route path="/about-us-page" element={<AboutUsPage />} />
          <Route path="/contact-us-page" element={<ContactUsPage />} />
          <Route path="/privacy-policy-page" element={<PrivacyPolicyPage />} />
          <Route path="/orderSuccessPage" element={<OrderSuccessPage />} />
          <Route path="/orderFailurePage" element={<OrderFailurePage />} />
        </Route>
      </Route>

      {/* مسیر جداگانه برای Drop */}
      <Route path="/drop" element={<Drop />} />
      <Route path="/login-register" element={<LoginPage />} />
      <Route path="/profile-page" element={<ProfilePage />} />
      <Route path="/update-page" element={<UpdatePage />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
    </Routes>
  );
}

export default App;
